import React, { useState } from 'react';
import { Input, Button, Modal, Spin, Checkbox, Radio, DatePicker } from 'antd';
import { usePayItemForm } from './hooks/usePayItemForm';

const { TextArea } = Input;

const P9132Form: React.FC = () => {
  const f = usePayItemForm();
  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!f.current) return;
    Modal.confirm({
      title: '確認刪除', content: `確定要刪除「${f.current.f932_01}」（${f.current.f932_11}）？`,
      okText: '刪除', okType: 'danger', cancelText: '取消', onOk: f.doDelete,
    });
  };
  const modeLabel = f.mode === 'add' ? '新增' : f.mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={f.loading}>
      <div className="max-w-2xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          薪資項目定義 (pw9132f1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {f.records.length > 0 ? `${f.currentIdx + 1} / ${f.records.length}` : '無資料'}
          </span>
        </h2>
        <div className="flex items-center gap-2 mb-4">
          <Input placeholder="代號查詢" value={searchText} onChange={e => setSearchText(e.target.value)}
            onPressEnter={() => searchText.trim() && f.quickSearch(searchText.trim())}
            disabled={f.isEditing} style={{ width: 150 }} maxLength={4} />
          <Button onClick={() => searchText.trim() && f.quickSearch(searchText.trim())} disabled={f.isEditing}>查詢</Button>
        </div>
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={f.navFirst} disabled={f.isEditing || !f.records.length}>|&lt;</Button>
          <Button size="small" onClick={f.navPrev} disabled={f.isEditing || f.currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={f.navNext} disabled={f.isEditing || f.currentIdx >= f.records.length - 1}>&gt;</Button>
          <Button size="small" onClick={f.navLast} disabled={f.isEditing || !f.records.length}>&gt;|</Button>
        </div>
        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-4">
            <label className="w-28 text-sm text-right">項目代號</label>
            <Input value={f.code} onChange={e => f.setCode(e.target.value)} maxLength={4}
              disabled={f.mode !== 'add'} style={{ width: 100 }} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-28 text-sm text-right">項目名稱</label>
            <Input value={f.name} onChange={e => f.setName(e.target.value)} maxLength={20}
              disabled={!f.isEditing} style={{ width: 300 }} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-28 text-sm text-right">類別代號</label>
            <Input value={f.catCode} onChange={e => f.setCatCode(e.target.value)} maxLength={4}
              disabled={!f.isEditing} style={{ width: 100 }} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-28 text-sm text-right">項目屬性</label>
            <Radio.Group value={f.attr} onChange={e => f.setAttr(e.target.value)} disabled={!f.isEditing}>
              <Radio value={1}>加項</Radio>
              <Radio value={2}>減項</Radio>
              <Radio value={3}>不處理</Radio>
            </Radio.Group>
          </div>
          <div className="flex items-center gap-4">
            <label className="w-28 text-sm text-right">啟用日期</label>
            <DatePicker value={f.startDate} onChange={v => f.setStartDate(v)}
              disabled={!f.isEditing} style={{ width: 180 }} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-28 text-sm text-right">停用日期</label>
            <DatePicker value={f.endDate} onChange={v => f.setEndDate(v)}
              disabled={!f.isEditing} style={{ width: 180 }} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-28 text-sm text-right">計入所得稅</label>
            <Checkbox checked={f.isTax} onChange={e => f.setIsTax(e.target.checked)} disabled={!f.isEditing} />
          </div>
          <div className="flex items-start gap-4">
            <label className="w-28 text-sm text-right pt-1">項目說明</label>
            <TextArea value={f.memo} onChange={e => f.setMemo(e.target.value)}
              disabled={!f.isEditing} rows={3} style={{ width: 400 }} />
          </div>
        </div>
        {f.current && f.mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6">
            建立: {f.current.f932_91} | 日期: {f.current.f932_92 || '-'} | 修改: {f.current.f932_93}
          </div>
        )}
        <div className="flex items-center gap-2">
          {!f.isEditing ? (
            <>
              <Button type="primary" onClick={f.startAdd}>新增</Button>
              <Button onClick={f.startEdit} disabled={!f.current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!f.current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={f.save}>儲存</Button>
              <Button onClick={f.cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P9132Form;
